module.exports = __webpack_public_path__ + "img/logo-footer.a3ab3b6a.png";